<script setup lang="ts">
import type { FishTransfer } from '@/types/v2';
import { computed, defineProps, withDefaults } from 'vue';
import type { OperationInfo } from '@/types/v2/task/animal-transfer/operation.types';
import TransferListItem from './TransferListItem.vue';

interface Props {
    transfers: FishTransfer[];
    transferInfo?: OperationInfo;
}

const props = withDefaults(defineProps<Props>(), {
    transfers: () => [],
    transferInfo: undefined
});

const hasTransfers = computed(() => props.transfers.length > 0 && props.transferInfo);
</script>

<template>
    <div v-if="hasTransfers" class="my-4">
        <ul class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <TransferListItem v-for="(transfer, index) in transfers" :key="transfer.key" :index="index"
                :transfer="transfer" :transferInfo="transferInfo" />
        </ul>
    </div>
</template>